import { LayerThicknessesNumeric } from '../constants';
import { LayerThickness, LayerThicknessRoc } from '../enums';

export function getLayerThicknessRoC(layerThicknenss: LayerThickness): number {
    switch (layerThicknenss) {
        case LayerThickness.Micron50:
            return LayerThicknessRoc.Micron50;
        case LayerThickness.Micron170:
            return LayerThicknessRoc.Micron170;
        case LayerThickness.Micron100:
        default:
            return LayerThicknessRoc.Micron100;
    }
}

export function getLayerThicknessId(layerThicknenss: number): number {
    switch (layerThicknenss) {
        case LayerThicknessRoc.Micron50:
            return LayerThickness.Micron50;
        case LayerThicknessRoc.Micron170:
            return LayerThickness.Micron170;
        case LayerThicknessRoc.Micron100:
        default:
            return LayerThickness.Micron100;
    }
}

export function getLayerThicknessIdFromNumeric(layerThicknenssNumeric: number): number {
    switch (layerThicknenssNumeric) {
        case LayerThicknessesNumeric.Micron50:
            return LayerThickness.Micron50;
        case LayerThicknessesNumeric.Micron170:
            return LayerThickness.Micron170;
        case LayerThicknessesNumeric.Micron100:
        default:
            return LayerThickness.Micron100;
    }
}
